let carouselPositions = {};
let carouselsInitialized = false;

function initializeCarousels() {
  const carouselContainers = document.querySelectorAll('.carousel-container');
  
  if (carouselContainers.length === 0) {
    return false;
  }
  
  let initializedCount = 0;
  
  carouselContainers.forEach(container => {
    const uniqueHandle = container.id.replace('collection-', '');
    
    // Skip if already initialized
    if (carouselPositions[uniqueHandle] !== undefined) {
      initializedCount++;
      return;
    }
    
    // Initialize this carousel
    carouselPositions[uniqueHandle] = 0;
    
    // Setup scroll tracking for mobile/tablet
    const carousel = container.querySelector('.products-carousel');
    if (carousel) {
      carousel.addEventListener('scroll', function() {
        updateScrollProgress(this, uniqueHandle);
      });
    }
    
    // Initialize button states and progress
    updateCarouselButtons(uniqueHandle);
    updateCarouselProgress(uniqueHandle);
    
    initializedCount++;
  });
  
  carouselsInitialized = true;
  return true;
}

function checkAndInitializeCarousels() {
  const carouselContainers = document.querySelectorAll('.carousel-container');
  
  if (carouselContainers.length > 0) {
    // If we have carousels but they're not initialized, initialize them
    const needsInitialization = Array.from(carouselContainers).some(container => {
      const uniqueHandle = container.id.replace('collection-', '');
      return carouselPositions[uniqueHandle] === undefined;
    });
    
    if (needsInitialization) {
      initializeCarousels();
    }
  }
}

function slideCarousel(uniqueHandle, direction) {
  // Check if this carousel is initialized, if not initialize it first
  if (carouselPositions[uniqueHandle] === undefined) {
    initializeCarousels();
    
    // If still not initialized after trying, bail out
    if (carouselPositions[uniqueHandle] === undefined) {
      return;
    }
  }
  
  // Only allow button navigation on desktop
  if (window.innerWidth < 1024) return;
  
  const track = document.getElementById(`track-${uniqueHandle}`);
  if (!track) {
    return;
  }
  
  const container = track.parentElement;
  const containerWidth = container.offsetWidth;
  const gap = window.innerWidth < 768 ? 16 : 24;
  const cardsPerView = getCardsPerView();
  const cardWidth = calculateCardWidth(containerWidth, cardsPerView, gap);
  const maxScroll = track.scrollWidth - containerWidth;
  
  const cardsToSlide = cardsPerView;
  const slideAmount = cardsToSlide * (cardWidth + gap);
  let newPosition = carouselPositions[uniqueHandle] + (slideAmount * direction);
  
  newPosition = Math.max(0, Math.min(maxScroll, newPosition));
  
  if (direction === 1 && newPosition > maxScroll - 10) {
    newPosition = maxScroll;
  }
  
  carouselPositions[uniqueHandle] = newPosition;
  track.style.transform = `translateX(-${carouselPositions[uniqueHandle]}px)`;
  
  // Update buttons and progress immediately after sliding
  updateCarouselButtons(uniqueHandle);
  updateCarouselProgress(uniqueHandle);
}

function getCardsPerView() {
  const width = window.innerWidth;
  if (width < 768) return 2;
  if (width < 1024) return 3;
  return 4;
}

function calculateCardWidth(containerWidth, cardsPerView, gap) {
  return (containerWidth - (gap * (cardsPerView - 1))) / cardsPerView;
}

function getProgressBarWidth() {
  const width = window.innerWidth;
  if (width < 768) return 0.4; // 40% on mobile
  if (width < 1024) return 0.6; // 60% on tablet
  return 0.8; // 80% on desktop
}

function updateCarouselButtons(uniqueHandle) {
  const container = document.getElementById(`collection-${uniqueHandle}`);
  const track = document.getElementById(`track-${uniqueHandle}`);
  
  if (!track || !container) {
    return;
  }
  
  const containerWidth = track.parentElement.offsetWidth;
  const maxScroll = track.scrollWidth - containerWidth;
  const prevBtn = container.querySelector('.carousel-btn-prev');
  const nextBtn = container.querySelector('.carousel-btn-next');

  // Ensure we have a position for this carousel
  if (typeof carouselPositions[uniqueHandle] === 'undefined') {
    carouselPositions[uniqueHandle] = 0;
  }

  const currentPosition = carouselPositions[uniqueHandle];

  // Only update buttons on desktop
  if (window.innerWidth >= 1024) {
    if (prevBtn) {
      prevBtn.disabled = currentPosition <= 0;
      prevBtn.style.opacity = currentPosition <= 0 ? '0.6' : '1';
    }
    
    if (nextBtn) {
      nextBtn.disabled = currentPosition >= maxScroll - 1;
      nextBtn.style.opacity = currentPosition >= maxScroll - 1 ? '0.6' : '1';
    }
  }
}

function updateCarouselProgress(uniqueHandle) {
  const container = document.getElementById(`collection-${uniqueHandle}`);
  const track = document.getElementById(`track-${uniqueHandle}`);
  
  if (!track || !container) {
    return;
  }
  
  const carousel = container.querySelector('.products-carousel');
  if (!carousel) return;
  
  const progressFill = document.getElementById(`progress-fill-${uniqueHandle}`);
  const progressWrapper = document.getElementById(`progress-${uniqueHandle}`);
  
  if (!progressFill || !progressWrapper) {
    return;
  }
  
  const containerWidth = carousel.offsetWidth;
  const trackWidth = track.scrollWidth;
  
  // NEW: Hide entire progress wrapper if content fits within container
  if (trackWidth <= containerWidth) {
    progressWrapper.classList.add('hidden');
    return;
  }
  
  // Show progress wrapper if there's content to scroll
  progressWrapper.classList.remove('hidden');
  
  const maxScroll = trackWidth - containerWidth;
  let currentPosition;
  
  if (window.innerWidth >= 1024) {
    // Desktop: Use transform position
    currentPosition = carouselPositions[uniqueHandle] || 0;
  } else {
    // Mobile/Tablet: Use scroll position
    currentPosition = carousel.scrollLeft;
  }
  
  // Calculate scroll percentage (0 to 1)
  const scrollPercent = currentPosition / maxScroll;
  
  // Get the width of the progress bar (40%, 60%, or 80%)
  const barWidthPercent = getProgressBarWidth();
  
  // Calculate maximum margin-left (so bar doesn't go beyond 100%)
  const maxMarginLeft = (1 - barWidthPercent) * 100;
  
  // Calculate margin-left based on scroll position
  const marginLeft = scrollPercent * maxMarginLeft;
  
  // Set the margin-left (clamped between 0 and maxMarginLeft)
  progressFill.style.marginLeft = Math.min(maxMarginLeft, Math.max(0, marginLeft)) + '%';
}

function updateScrollProgress(carousel, uniqueHandle) {
  // This function is specifically for mobile/tablet scrolling
  const track = carousel.querySelector('.products-track');
  const progressFill = document.getElementById(`progress-fill-${uniqueHandle}`);
  const progressWrapper = document.getElementById(`progress-${uniqueHandle}`);
  
  if (!track || !progressFill || !progressWrapper) return;
  
  const containerWidth = carousel.offsetWidth;
  const trackWidth = track.scrollWidth;
  
  // NEW: Hide entire progress wrapper if content fits within container
  if (trackWidth <= containerWidth) {
    progressWrapper.classList.add('hidden');
    return;
  }
  
  // Show progress wrapper if there's content to scroll
  progressWrapper.classList.remove('hidden');
  
  const scrollLeft = carousel.scrollLeft;
  const maxScroll = trackWidth - containerWidth;
  
  // Calculate scroll percentage (0 to 1)
  const scrollPercent = scrollLeft / maxScroll;
  
  // Get the width of the progress bar (40%, 60%, or 80%)
  const barWidthPercent = getProgressBarWidth();
  
  // Calculate maximum margin-left (so bar doesn't go beyond 100%)
  const maxMarginLeft = (1 - barWidthPercent) * 100;
  
  // Calculate margin-left based on scroll position
  const marginLeft = scrollPercent * maxMarginLeft;
  
  // Set the margin-left (clamped between 0 and maxMarginLeft)
  progressFill.style.marginLeft = Math.min(maxMarginLeft, Math.max(0, marginLeft)) + '%';
}

function scrollTabIntoView(button, sectionId) {
  const tabContainer = document.getElementById(`collectionSelector-${sectionId}`);
  if (!tabContainer) return;
  
  // Check if tabs container has horizontal scroll (overflow)
  const containerWidth = tabContainer.offsetWidth;
  const scrollWidth = tabContainer.scrollWidth;
  const hasHorizontalScroll = scrollWidth > containerWidth;
  
  if (!hasHorizontalScroll) return;
  
  // Always scroll to position the selected tab as the FIRST visible tab
  const targetScrollLeft = button.offsetLeft;
  
  // Ensure scroll position is within bounds
  const maxScroll = scrollWidth - containerWidth;
  const boundedScrollLeft = Math.max(0, Math.min(maxScroll, targetScrollLeft));
  
  // Smooth scroll to make this tab the first visible tab
  tabContainer.scrollTo({
    left: boundedScrollLeft,
    behavior: 'smooth'
  });
}

function loadCollectionProducts(button, event) {
  event.preventDefault();
  
  const sectionId = button.dataset.sectionId;
  const collectionHandle = button.dataset.collectionHandle;
  const uniqueHandle = sectionId + '-' + collectionHandle;
  
  // Find the section wrapper
  const sectionWrapper = document.querySelector('[data-section-id="' + sectionId + '"]');
  
  // Deactivate all tabs in this specific section only
  if (sectionWrapper) {
    const allTabsInSection = sectionWrapper.querySelectorAll('.collection-tab');
    allTabsInSection.forEach(tab => {
      tab.classList.remove('active');
    });
  }
  
  // Activate clicked tab
  button.classList.add('active');

  // Scroll the tab into view
  scrollTabIntoView(button, sectionId);

  // Hide all carousels in this specific section
  const sectionCarousels = document.querySelectorAll('[data-section-id="' + sectionId + '"] .carousel-container');
  const sectionProgress = document.querySelectorAll('[data-section-id="' + sectionId + '"] .carousel-progress-wrapper');
  
  sectionCarousels.forEach(el => el.style.display = 'none');
  sectionProgress.forEach(el => el.style.display = 'none');

  // Show selected carousel
  const selectedCarousel = document.getElementById(`collection-${uniqueHandle}`);
  const selectedProgress = document.getElementById(`progress-${uniqueHandle}`);
  
  if (selectedCarousel) selectedCarousel.style.display = 'block';
  if (selectedProgress) selectedProgress.style.display = 'block';

  // Reset position for the new carousel
  carouselPositions[uniqueHandle] = 0;
  const track = document.getElementById(`track-${uniqueHandle}`);
  if (track) {
    track.style.transform = 'translateX(0)';
  }
  
  // Reset scroll position for mobile/tablet
  const carousel = selectedCarousel?.querySelector('.products-carousel');
  if (carousel) {
    carousel.scrollLeft = 0;
  }
  
  // Force a complete refresh of the carousel state
  setTimeout(() => {
    // Recalculate everything for the newly visible carousel
    updateCarouselButtons(uniqueHandle);
    updateCarouselProgress(uniqueHandle);
    
    // Trigger a resize event to ensure proper calculations
    window.dispatchEvent(new Event('resize'));
  }, 150);
}

function setupEventListeners() {
  // Collection tab clicks
  document.addEventListener('click', function(event) {
    if (event.target.closest('.collection-tab')) {
      const button = event.target.closest('.collection-tab');
      loadCollectionProducts(button, event);
    }
    
    // Carousel button clicks
    if (event.target.closest('.carousel-btn')) {
      const button = event.target.closest('.carousel-btn');
      const uniqueHandle = button.dataset.carouselHandle;
      const direction = parseInt(button.dataset.direction);
      
      if (uniqueHandle && direction) {
        // Ensure carousels are initialized before sliding
        checkAndInitializeCarousels();
        slideCarousel(uniqueHandle, direction);
      }
    }
  });
}

function setupMutationObserver() {
  const observer = new MutationObserver(function(mutations) {
    let shouldInitialize = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        Array.from(mutation.addedNodes).forEach(function(node) {
          if (node.nodeType === 1) {
            // Check if this node or its children contain carousels
            if (node.classList && node.classList.contains('carousel-container')) {
              shouldInitialize = true;
            } else if (node.querySelector && node.querySelector('.carousel-container')) {
              shouldInitialize = true;
            }
          }
        });
      }
    });
    
    if (shouldInitialize) {
      setTimeout(() => {
        checkAndInitializeCarousels();
      }, 100);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Initialize everything when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  setupEventListeners();
  setupMutationObserver();
  
  // Initial check for carousels
  setTimeout(() => {
    checkAndInitializeCarousels();
  }, 500);
});

// Handle window resize
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    // Update carousels (your existing code)
    Object.keys(carouselPositions).forEach(uniqueHandle => {
      const track = document.getElementById(`track-${uniqueHandle}`);
      const container = document.getElementById(`collection-${uniqueHandle}`);
      
      // Only update visible carousels
      if (track && container && container.style.display !== 'none') {
        const carousel = container.querySelector('.products-carousel');
        
        if (window.innerWidth >= 1024) {
          // Desktop: Recalculate transform position
          const containerWidth = carousel.offsetWidth;
          const maxScroll = track.scrollWidth - containerWidth;
          const gap = window.innerWidth < 768 ? 16 : 24;
          const cardsPerView = getCardsPerView();
          const cardWidth = calculateCardWidth(containerWidth, cardsPerView, gap);
          
          // Recalculate position to maintain relative position
          const currentCardIndex = Math.round(carouselPositions[uniqueHandle] / (cardWidth + gap));
          carouselPositions[uniqueHandle] = currentCardIndex * (cardWidth + gap);
          
          // Constrain to new maxScroll
          carouselPositions[uniqueHandle] = Math.max(0, Math.min(maxScroll, carouselPositions[uniqueHandle]));
          
          track.style.transform = `translateX(-${carouselPositions[uniqueHandle]}px)`;
        }
        
        // Always update progress bar on resize
        updateCarouselProgress(uniqueHandle);
        updateCarouselButtons(uniqueHandle);
      }
    });
  }, 250);
});

// Expose initialization function for async-loaded content
// @ts-ignore
window.initializeCarouselsManually = function() {
  return initializeCarousels();
};

// Expose check function for external use
// @ts-ignore
window.checkAndInitializeCarousels = checkAndInitializeCarousels;